import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'itemsFilter',
    pure: false
})
export class itemsFilterPipe implements PipeTransform {
    transform(items: any[], filter: Object): any {
        if (!items || !filter) {
            return items;
        }
        // filter items array, items which match and return true will be
        // kept, false will be filtered out
        return items.filter(item => item.type.indexOf(filter) !== -1);
    }
}

@Pipe({
    name: 'kryptomonRanking',
    pure: false
})
export class kryptomonRankingPipe implements PipeTransform {
    transform(items: any[], filter: Object): any {
        if (!items || !filter) {
            return items;
        }
        // filter items array, items which match and return true will be
        // kept, false will be filtered out
        return items.filter(item => item.data.tierName.indexOf(filter) !== -1);
    }
}

@Pipe({
    name: 'assetFilter',
    pure: false
})
export class assetFilterPipe implements PipeTransform {
    transform(items: any[], filter: Object): any {
        if (!items || !filter) {
            return items;
        }
        // filter items array, items which match and return true will be
        // kept, false will be filtered out
        console.log(items)
        return items.filter(item => item.metadata.filter_category.toLowerCase().indexOf(filter) !== -1);
    }
}

@Pipe({
    name: 'activitiesFilter',
    pure: false
})
export class activitiesFilterPipe implements PipeTransform {
    transform(items: any[], filter: Object): any {
        if (!items || !filter) {
            return items;
        }
        // filter items array, items which match and return true will be
        // kept, false will be filtered out
        return items.filter(item => item.title.toLowerCase().indexOf(filter) !== -1);
    }
}

@Pipe({
    name: 'itemsFilterType',
    pure: false
})
export class itemsFilterTypePipe implements PipeTransform {
    transform(items: any[], filter: Object): any {
        if (!items || !filter) {
            return items;
        }
        // filter items array, items which match and return true will be
        // kept, false will be filtered out
        return items.filter(item => item?.metadata?.typeFormatted?.toLowerCase().indexOf(filter) !== -1);
    }
}

@Pipe({
    name: 'merchFilterType',
    pure: false
})
export class merchFilterPipe implements PipeTransform {
    transform(items: any[], filter: any): any {
        if (!items) {
            return items;
        }
        // filter items array, items which match and return true will be
        // kept, false will be filtered out
        //console.log(filter)
        if (filter.nftOwner) {
            return items.filter(item => (item.custom == filter.custom && item.title.indexOf('VAR') == false));
        } else {
            return items.filter(item => (item.custom == filter.custom && item.nftOwner == filter.nftOwner));
        }

    }
}

@Pipe({
    name: 'kryptomonMarketRanking',
    pure: false
})
export class kryptomonMarketRankingPipe implements PipeTransform {
    transform(items: any[], filter: any): any {
        if (!items || !filter || filter == '') {
            return items
        }
        return items.filter(item => filter.indexOf(item.data.tierName) !== -1);
    }
}

@Pipe({
    name: 'kryptomonMainPower',
    pure: false
})
export class kryptomonMainPowerPipe implements PipeTransform {
    transform(items: any[], filter: any): any {
        if (!items || !filter) {
            return items;
        }
        // filter items array, items which match and return true will be
        // kept, false will be filtered out
        return items.filter(item => item.data.data.kryptomon.mainTalentAmount >= filter.minVal && item.data.data.kryptomon.mainTalentAmount <= filter.maxVal);
    }
}

@Pipe({
    name: 'kryptomonSecondPower',
    pure: false
})
export class kryptomonSecondPowerPipe implements PipeTransform {
    transform(items: any[], filter: any): any {
        if (!items || !filter) {
            return items;
        }
        // filter items array, items which match and return true will be
        // kept, false will be filtered out
        return items.filter(item => item.data.data.kryptomon.secondTalentAmount >= filter.minVal && item.data.data.kryptomon.secondTalentAmount <= filter.maxVal);
    }
}

@Pipe({
    name: 'spellsOnboardingFilter',
    pure: false
})
export class spellsOnboardingFilterPipe implements PipeTransform {
    transform(items: any[], filter: any): any {
        if (!items || !filter || filter == '') {
            return items
        }
        return items.filter(item => item.id !== filter);
    }
}
